import { useEffect } from 'react'
import getImageUrl from './get-image-url'
import Breadcrumb from './Breadcrumb.jsx'
import PageHeader from './PageHeader.jsx'
import { Icon } from '@iconify/react'

import scrollIntoView from 'scroll-into-view-if-needed'

import { useMediaQuery } from 'react-responsive'

import { motion } from 'framer-motion'

const scr = (node) => {
  scrollIntoView(node, {
    behavior: 'smooth',
    scrollMode: 'if-needed',
    block: 'start',
    inline: 'start',
  })
}

const fadeInBottom = {
  hidden: {
    opacity: 0,
    y: 80,
  },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      y: {
        duration: 1.3,
        ease: [0.165, 0.84, 0.44, 1],
        delay: i,
      },
      opacity: {
        duration: 0.3,
        delay: i,
      },
    },
  }),
}

const Btn = (props) => {
  return (
    <>
      <motion.div
        variants={fadeInBottom}
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          threshold: 0.5,
        }}
        custom={props.delay}
      >
        <button onClick={() => scr(document.querySelector(props.scrTarget))}>
          <div className="flex flex-col justify-center items-center h-full md:py-[27px]">
            <div>
              <div className="image flex justify-center items-center">
                <img
                  src={getImageUrl(props.image)}
                  alt=""
                  className="h-full w-auto"
                />
              </div>
            </div>
            <p className="mt-2">{props.title}</p>
            <div>
              <Icon
                icon="ep:arrow-up"
                rotate={2}
                className="icon w-[calc(50vw/7.5)] h-[calc(50vw/7.5)] md:w-[calc(30vw/10.24)] md:h-[calc(30vw/10.24)] mx-auto"
              />
            </div>
          </div>
        </button>
      </motion.div>
      <style jsx>{`
        button {
          background: #003475 0% 0% no-repeat padding-box;
          box-shadow: 8px 8px 10px #00347566;
          width: calc(271vw / 7.5);
          max-width: 271px;
          border-radius: 999px;
          margin-inline: auto;
          aspect-ratio: 1;
          color: #ffffff;
          transition: background 0.15s, transform 0.3s ease-out;
          transform: scale(1);
        }
        button:hover {
          background: #003475 0% 0% no-repeat padding-box;
        }
        button:active {
          transform: scale(0.95);
        }
        .image {
          height: calc(80vw / 7.5);
          display: flex;
          justify-content: center;
        }
        .image img {
          height: 100%;
        }
        p {
          text-align: center;
          font: normal normal bold calc(34vw / 7.5) Noto Sans JP;
        }
        @media (min-width: 1024px) {
          button {
            background: #003475 0% 0% no-repeat padding-box;
            box-shadow: 8px 8px 10px #00347566;
            width: min(210px, calc(210vw / 10.24));
            height: min(210px, calc(210vw / 10.24));
            border-radius: 999px;
            margin-left: 0;
            margin-right: 0;
            color: #ffffff;
          }
          button:hover {
            background: #1b5fb4 0% 0% no-repeat padding-box;
          }
          .image {
            height: clamp(0px, calc(60vw / 10.24), 60px);
          }
          .image img {
            height: 100%;
          }
          p {
            text-align: center;
            font: normal normal bold min(30px, calc(30vw / 10.24)) Noto Sans JP;
          }
          .icon {
            width: calc(30vw / 10.24);
            height: calc(30vw / 10.24);
            margin-left: auto;
            margin-right: auto;
            margin-top: calc(12vw / 10.24);
          }
        }
      `}</style>
    </>
  )
}

const Section1Box = (props) => {
  const isMD = useMediaQuery({ query: '(min-width: 768px)' })

  const Left = () => {
    return (
      <>
        <div className="image">
          <img
            src={props.icon}
            alt=""
          />
        </div>
        <p className="title">{props.title}</p>
        <style jsx>{`
          .box {
            background: #003475 0% 0% no-repeat padding-box;
            border-radius: 15px;
            padding: calc(52vw / 7.5) calc(27vw / 7.5);
            height: 100%;
            display: flex;
            justify-content: center;
          }
          .image {
            display: flex;
            justify-content: center;
            align-items: flex-end;
            flex-grow: 1;
          }
          .title {
            text-align: center;
            font: normal normal bold calc(40vw / 7.5) Noto Sans JP;
            color: #ffffff;
            margin-top: calc(20vw / 7.5);
          }
          .paragrah {
            font: normal normal normal calc(35vw / 7.5) Noto Sans JP;
            color: #ffffff;
          }
          @media (min-width: 768px) {
            .box {
              background: #003475 0% 0% no-repeat padding-box;
              border-radius: 30px;
              padding: 70px 54px 50px;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: normal;
            }
            .image {
              display: flex;
              justify-content: center;
              align-items: flex-end;
              flex-grow: 1;
            }
            .title {
              text-align: center;
              font: normal normal bold 30px/80px Noto Sans JP;
              color: #ffffff;
            }
            .paragrah {
              font: normal normal normal 22px/40px Noto Sans JP;
              color: #ffffff;
            }
          }
        `}</style>
      </>
    )
  }

  return (
    <>
      <motion.div
        variants={fadeInBottom}
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          threshold: 0.5,
        }}
        custom={props.delay}
      >
        <div className="box">
          {isMD ? (
            <Left />
          ) : (
            <div className="w-[calc(200vw/7.5)] shrink-0">
              <Left />
            </div>
          )}
          <p className="paragrah">{props.paragrah}</p>
        </div>
      </motion.div>
      <style jsx>{`
        .box {
          background: #003475 0% 0% no-repeat padding-box;
          border-radius: 15px;
          padding: calc(52vw / 7.5) calc(27vw / 7.5);
          height: 100%;
          display: flex;
          gap: calc(48vw / 7.5);
        }
        .image {
          display: flex;
          justify-content: center;
          align-items: flex-end;
          flex-grow: 1;
        }
        .title {
          text-align: center;
          font: normal normal bold calc(40vw / 7.5) Noto Sans JP;
          color: #ffffff;
        }
        .paragrah {
          font: normal normal normal calc(34vw / 7.5) Noto Sans JP;
          color: #ffffff;
        }
        @media (min-width: 768px) {
          .box {
            background: #003475 0% 0% no-repeat padding-box;
            border-radius: 30px;
            padding: 70px 54px 50px;
            height: 100%;
            display: flex;
            flex-direction: column;
            gap: 0;
          }
          .image {
            display: flex;
            justify-content: center;
            align-items: flex-end;
            flex-grow: 1;
          }
          .title {
            text-align: center;
            font: normal normal bold 30px/80px Noto Sans JP;
            color: #ffffff;
          }
          .paragrah {
            font: normal normal normal 22px/40px Noto Sans JP;
            color: #ffffff;
          }
        }
      `}</style>
    </>
  )
}

const SectionCaptionBox = (props) => {
  return (
    <>
      <motion.div
        variants={fadeInBottom}
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          threshold: 0.5,
        }}
        custom={props.delay}
      >
        <div className="box">
          <div className="image">
            <img
              src={props.image}
              alt=""
            />
          </div>
          <p className="title">{props.title}</p>
          <p
            className="paragrah"
            dangerouslySetInnerHTML={{ __html: props.paragrah }}
          ></p>
        </div>
      </motion.div>
      <style jsx>{`
        .box {
          max-width: 480px;
        }
        .title {
          text-align: center;
          font-size: calc(40vw / 7.5);
          font-weight: bold;
          margin-top: calc(32vw / 7.5);
        }
        .paragrah {
          text-align: center;
          font-size: calc(35vw / 7.5);
          margin-top: calc(32vw / 7.5);
          max-width: calc(480vw / 7.5);
          margin-left: auto;
          margin-right: auto;
        }
        @media (min-width: 768px) {
          .box {
            max-width: 480px;
          }
          .title {
            text-align: center;
            font: normal normal bold 30px/80px Noto Sans JP;
            margin-top: 0;
          }
          .paragrah {
            text-align: center;
            font: normal normal normal 22px/40px Noto Sans JP;
            margin-top: 0;
            max-width: none;
          }
        }
      `}</style>
    </>
  )
}

const AboutDemolitionWork = () => {
  useEffect(() => {
    const hash = window.location.hash
    if (hash) {
      const node = document.querySelector(hash)
      setTimeout(() => {
        scr(node)
      }, 800)
    }

    window.addEventListener('hashchange', () => {
      const hash = window.location.hash
      if (hash) {
        const node = document.querySelector(hash)
        setTimeout(() => {
          scr(node)
        }, 800)
      }
    })
  }, [])

  const isMD = useMediaQuery({ query: '(min-width: 768px)' })
  const isLG = useMediaQuery({ query: '(min-width: 1024px)' })

  return (
    <>
      <div>
        <PageHeader
          title={'解体工事について'}
          image={getImageUrl('ABOUT-DEMOLITION-WORK.png')}
        />
        <div className="content-area">
          <Breadcrumb
            current={'解体工事について'}
            site_url={import.meta.env.VITE_SITE_URL}
            items={[]}
          />
        </div>
        <div className="mt-[calc(94vw/7.5)] md:mt-[116px]">
          <motion.div
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              threshold: 0.5,
            }}
          >
            <p className="paragrah-1 px-[35px] md:px-0">
              横浜総合建設では、木造・鉄骨造・RC造など建築物解体から店舗・住宅の内装解体など
              {isMD && <br />}
              建物の大小を問わず解体工事を請け負っております。
              {isMD && <br />}
              自社施工によるスピーディーで柔軟な解体工事で皆様のご要望にお応えいたします。
              <br />
              不動産経験者の多い弊社ではその知識やノウハウを活かし、
              {isMD && <br />}
              解体後の土地運用も視野に入れた解体工事や解体工事後の造成工事・
              {isMD && <br />}
              外構工事にも対応いたしますので、安心してお任せください。
            </p>
          </motion.div>
        </div>
        <div className="grid grid-cols-2 lg:flex justify-center gap-[calc(64vw/7.5)] md:gap-[52px] mt-[calc(54vw/7.5)] md:mt-[140px] px-[calc(70vw/7.5)]">
          <Btn
            image={'about-demolition-work-btn-1.png'}
            title={'建築物解体'}
            scrTarget="#section-1"
          />
          <Btn
            image={'about-demolition-work-btn-2.png'}
            title={'内装解体'}
            scrTarget="#section-2"
            delay={0.3}
          />
          <Btn
            image={'about-demolition-work-btn-3.png'}
            title={'外構解体'}
            scrTarget="#section-3"
            delay={0.6}
          />
          <Btn
            image={'about-demolition-work-btn-4.png'}
            title={'その他'}
            scrTarget="#section-4"
            delay={0.9}
          />
        </div>
        <div
          id="section-1"
          className={isLG && 'pt-[226px] pb-[230px]'}
        >
          <div
            className={
              isLG ||
              'pt-[calc(131vw/7.5)] pb-[calc(153vw/7.5)] px-[calc(68vw/7.5)] bg-[#003475] mt-[calc(90vw/7.5)]'
            }
          >
            <motion.div
              variants={fadeInBottom}
              initial="hidden"
              whileInView="visible"
              viewport={{
                once: true,
                threshold: 0.5,
              }}
            >
              <h2 className="!text-white lg:!text-[#2964B6]">建築物解体</h2>
            </motion.div>

            {isLG || (
              <motion.div
                variants={fadeInBottom}
                initial="hidden"
                whileInView="visible"
                viewport={{
                  once: true,
                  threshold: 0.5,
                }}
              >
                <img
                  src={getImageUrl('about-demolition-work-section-1-image.png')}
                  alt=""
                  className="mt-[min(calc(100vw/7.5),50px)] mx-auto"
                />
              </motion.div>
            )}
            <motion.div
              variants={fadeInBottom}
              initial="hidden"
              whileInView="visible"
              viewport={{
                once: true,
                threshold: 0.5,
              }}
            >
              <div className="lg:flex justify-center mt-[min(calc(100vw/7.5),50px)] lg:mt-[70px] max-w-[1400px] mx-auto">
                <div className="box-1">
                  <p className="lg:w-[min(calc(528vw/19.2),528px)]">
                    解体工事はただ建物を壊すわけではありません。
                    木造・鉄骨造・RC造など構造の建築物があり、
                    その状況や周辺環境によって適切な解体方法を
                    選択しなければなりません。私たちは解体は
                    「工事」ではなく、「サービス」という考えの下、解体を依頼される皆様や近隣の方々のことも配慮した高品質な解体工事をご提供しています。
                  </p>
                </div>
                {isLG && (
                  <div className="w-1/2">
                    <img
                      src={getImageUrl('about-demolition-work-section-1-image.png')}
                      alt=""
                      className="h-full w-auto object-cover"
                    />
                  </div>
                )}
              </div>
            </motion.div>
          </div>
          <motion.div
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              threshold: 0.5,
            }}
          >
            <h3 className="mt-[calc(135vw/7.5)] md:mt-[140px]">解体可能な建物</h3>
          </motion.div>

          <div className="grid px-[calc(70vw/7.5)] lg:px-0 lg:grid-cols-3 max-w-[1108px] mt-[68px] mx-auto gap-[calc(52vw/7.5)] md:gap-[28px] pb-[calc(117vw/7.5)] lg:pb-0">
            <Section1Box
              icon={getImageUrl('about-demolition-work-section-1-icon-1.png')}
              title={`木造解体`}
              paragrah={`木造一軒家の場合は狭い住宅地での作業になるため、近隣への配慮を心がけた工事をいたします。`}
            />
            <Section1Box
              icon={getImageUrl('about-demolition-work-section-1-icon-2.png')}
              title={`鉄骨造解体`}
              paragrah={`鉄骨住宅や工場・倉庫・体育館など鉄骨建物の解体も承ります。廃棄物の処理もお任せください。`}
              delay={0.3}
            />
            <Section1Box
              icon={getImageUrl('about-demolition-work-section-1-icon-3.png')}
              title={`RC造解体`}
              paragrah={`RC住宅だけでなくマンション・工場・ビルなど大型で強固なRC造の建物の解体も承ります。`}
              delay={0.6}
            />
          </div>
        </div>
        <div
          id="section-2"
          className="bg-[#F4FBFF] pt-[calc(133vw/7.5)] pb-[calc(116vw/7.5)] lg:pt-[212px] lg:pb-[190px]"
        >
          <motion.div
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              threshold: 0.5,
            }}
          >
            <h2>内装解体</h2>
          </motion.div>
          <motion.div
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              threshold: 0.5,
            }}
          >
            <div className="lg:flex justify-cente mt-[min(calc(100vw/7.5),50px)] lg:mt-[70px] max-w-[1400px] mx-auto">
              <div className="lg:w-1/2 px-[min(calc(55vw/7.5),28px)] lg:px-0">
                <img
                  src={getImageUrl('about-demolition-work-section-2-image.png')}
                  alt=""
                  className="xl:w-auto mx-auto lg:mx-0 mb-[calc(-190vw/7.5)] lg:mb-0 relative z-10 lg:object-cover lg:h-full lg:w-full"
                />
              </div>
              <div className="box-1 pt-[calc(220vw/7.5)] px-[calc(70vw/7.5)] pb-[calc(152vw/7.5)] lg:p-0">
                <p className="lg:w-[min(calc(528vw/19.2),528px)]">
                  店舗・事務所・マンションの一室・住宅などの
                  内装解体を承ります。退去後の原状回復、改修に伴う内装解体など物件や条件によって
                  どこまで解体するかは異なりますが横浜総合建設ではスケルトン解体から一部の
                  解体まで対応可能です。リフォーム・リノベーションなどで分離発注を
                  ご検討の方はぜひご連絡ください。
                </p>
              </div>
            </div>
          </motion.div>
          <motion.div
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              threshold: 0.5,
            }}
          >
            <h3 className="mt-[calc(125vw/7.5)] mb:mt-[140px]">内装解体の種類</h3>
          </motion.div>
          <div className="content-area mt-[60px]">
            <div className="grid md:grid-cols-2 justify-center gap-[42px]">
              <SectionCaptionBox
                image={getImageUrl('about-demolition-work-section-2-caption-1.png')}
                title={`住宅内装解体`}
                paragrah={`住宅・マンションなどの退去・リフォーム・${
                  isMD ? '<br />' : ''
                }リノベーションに伴う内装解体を行ないます。${isMD ? '<br />' : ''}
                マンションなど共有部分の改装時にも${isMD ? '<br />' : ''}対応いたします。`}
              />
              <SectionCaptionBox
                image={getImageUrl('about-demolition-work-section-2-caption-2.png')}
                title={`店舗内装解体`}
                paragrah={`テナント撤去時や居ぬき物件などの${
                  isMD ? '<br />' : ''
                }スケルトン工事・原状回復工事を行ないます。${
                  isMD ? '<br />' : ''
                }改修による解体にも対応いたします。${
                  isMD ? '<br />' : ''
                }一度解体のプロにご相談ください。`}
                delay={0.3}
              />
            </div>
          </div>
        </div>
        <div
          id="section-3"
          className="pt-[calc(158vw/7.5)] pb-[calc(170vw/7.5)]  lg:pt-[236px] lg:pb-[230px]"
        >
          <motion.div
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              threshold: 0.5,
            }}
          >
            <h2>外構解体</h2>
          </motion.div>
          <motion.div
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              threshold: 0.5,
            }}
          >
            <div className="lg:flex justify-center mt-[min(calc(100vw/7.5),50px)] lg:mt-[70px] max-w-[1400px] mx-auto">
              {isLG || (
                <div className="px-[calc(55vw/7.5)]">
                  <img
                    src={getImageUrl('about-demolition-work-section-3-image.webp')}
                    alt=""
                    className="mb-[calc(-250vw/7.5)] mx-auto"
                  />
                </div>
              )}
              <div className="box-1 pt-[calc(290vw/7.5)] pb-[calc(152vw/7.5)] px-[calc(70vw/7.5)]">
                <p className="lg:w-[min(calc(528vw/19.2),528px)]">
                  建物の解体工事だけではなく、建物周辺のブロック塀・擁壁・コンクリート土間・アスファルトなど外構解体工事にも対応いたします。外構の解体は振動や騒音を伴うため、防音・防振対策や泥水の流出などが無いよう、細心の注意を払った外構解体を行ないます。外構解体も横浜総合建設にお任せください。
                </p>
              </div>
              {isLG && (
                <div className="w-1/2">
                  <img
                    src={getImageUrl('about-demolition-work-section-3-image.webp')}
                    alt=""
                    className="w-[calc(437vw/7.5)] xl:w-auto  mx-auto lg:mx-0 mb-[calc(-190vw/7.5)] lg:mb-0 relative z-10 lg:object-cover lg:h-full mx-a"
                  />
                </div>
              )}
            </div>
          </motion.div>
          <motion.div
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              threshold: 0.5,
            }}
          >
            <h3 className="mt-[140px]">外構解体の種類</h3>
          </motion.div>
          <div className="content-area mt-[60px]">
            <div className="grid md:grid-cols-2 justify-center gap-[42px]">
              <SectionCaptionBox
                image={getImageUrl('about-demolition-work-section-3-caption-1.png')}
                title={`ブロック塀・RC擁壁の解体`}
                paragrah={`塀や擁壁の解体だけではなく、${
                  isMD ? '<br />' : ''
                }新設工事も承ります。倒れそうで危険な${
                  isMD ? '<br />' : ''
                }ブロック塀や現在の基準では不適格と${
                  isMD ? '<br />' : ''
                }なってしまう擁壁などがありましたら${isMD ? '<br />' : ''}ご相談ください。`}
              />
              <SectionCaptionBox
                image={getImageUrl('about-demolition-work-section-3-caption-2.png')}
                title={`土間・アスファルトの撤去`}
                paragrah={`駐車スペースや建物周囲にある${
                  isMD ? '<br />' : ''
                }コンクリート土間やアスファルトの${
                  isMD ? '<br />' : ''
                } 解体・撤去工事を行ないます。${isMD ? '<br />' : ''}住宅地では近隣にご迷惑が${
                  isMD ? '<br />' : ''
                }かからないよう細心の注意を払います。`}
                delay={0.3}
              />
            </div>
          </div>
        </div>
        <div
          id="section-4"
          className="bg-[#F4FBFF] pt-[calc(130vw/7.5)] pb-[calc(60vw/7.5)] lg:pt-[206px] lg:pb-[230px] md:px-0"
        >
          <motion.div
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              threshold: 0.5,
            }}
          >
            <h2>解体付帯業務</h2>
          </motion.div>
          {/* <div className="lg:flex justify-center mt-[min(calc(100vw/7.5),50px)] lg:mt-[70px] lg:max-w-[1400px] mx-auto max-w-[calc(610vw/7.5)]">
            <div className="lg:w-1/2">
              <img
                src={getImageUrl('about-demolition-work-section-4-image.png')}
                alt=""
                className="lg:h-full lg:object-cover"
              />
            </div>
            <div className="box-2">
              <div className="lg:max-w-[424px]">
                <h4>樹木の伐採・抜根</h4>
                <p className="lg:max-w-[424px]">
                  樹木の伐採・抜根作業を承ります。
                  {isMD && <br />}
                  直径1メートル以上の樹木にも
                  {isMD && <br />}
                  対応いたします。尚、剪定作業については
                  {isMD && <br />}
                  承っておりませんのでご了承ください。
                </p>
              </div>
            </div>
          </div> */}
          <motion.div
            variants={fadeInBottom}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              threshold: 0.5,
            }}
          >
            <div className="lg:flex justify-center mt-[min(calc(100vw/7.5),50px)] lg:mt-[70px] max-w-[1400px] mx-auto">
              <div className="lg:w-1/2 px-[min(calc(55vw/7.5),28px)] lg:px-0">
                <img
                  src={getImageUrl('about-demolition-work-section-4-image.png')}
                  alt=""
                  className="xl:w-auto mx-auto lg:mx-0 mb-[calc(-190vw/7.5)] lg:mb-0 relative z-10 lg:object-cover lg:h-full lg:w-full lg:object-right"
                />
              </div>
              <div className="box-1 lg:!items-start flex-col pt-[calc(220vw/7.5)] px-[calc(70vw/7.5)] pb-[calc(152vw/7.5)] lg:p-0">
                <h4 className="font-bold lg:text-[30px] text-white text-center text-[20px] lg:text-left">
                  樹木の伐採・抜根
                </h4>
                <p className="mt-[20px] text-center lg:text-left">
                  樹木の伐採・抜根作業を承ります。
                  {isMD && <br />}
                  直径1メートル以上の樹木にも
                  {isMD && <br />}
                  対応いたします。尚、剪定作業については
                  {isMD && <br />}
                  承っておりませんのでご了承ください。
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
      <style jsx>{`
        .paragrah-1 {
          font: normal normal normal calc(34vw / 7.5) Noto Sans JP;
        }
        h2 {
          text-align: center;
          font: normal normal bold calc(50vw / 7.5) Noto Sans JP;
          color: #2964b6;
        }
        h3 {
          text-align: center;
          font: normal normal bold calc(50vw / 7.5) Noto Sans JP;
          color: #2964b6;
          border-bottom: 6px solid #2964b6;
          width: fit-content;
          margin-left: auto;
          margin-right: auto;
          padding-bottom: 16px;
        }
        .box-1 {
          background: #003475 0% 0% no-repeat padding-box;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .box-1 p {
          font-size: calc(35vw / 7.5);
          line-height: min(calc(60vw / 7.5), 50px);
          letter-spacing: 0px;
          color: #ffffff;
        }
        .box-2 {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .box-2 h4 {
          text-align: center;
          font: normal normal bold calc(40vw / 7.5) / calc(80vw / 7.5) Noto Sans JP;
          margin-top: calc(32vw / 7.5);
        }
        .box-2 p {
          font: normal normal normal calc(35vw / 7.5) / calc(50vw / 7.5) Noto Sans JP;
          margin-top: calc(32vw / 7.5);
        }
        @media (min-width: 1024px) {
          h2 {
            text-align: center;
            font: normal normal bold 80px/80px Noto Sans JP;
            color: #2964b6;
          }
          .box-1 {
            background: #003475 0% 0% no-repeat padding-box;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: calc(162vw / 19.2) calc(86vw / 19.2);
            width: 50%;
          }

          .box-2 {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 calc(76vw / 19.2);
            width: 50%;
          }
          .box-2 h4 {
            font: normal normal bold 30px/80px Noto Sans JP;
          }
          .box-2 p {
            font: normal normal normal 22px/40px Noto Sans JP;
          }
        }
        @media (min-width: 768px) {
          .paragrah-1 {
            text-align: center;
            font: normal normal normal 24px/50px Noto Sans JP;
          }
          h3 {
            text-align: center;
            font: normal normal bold 54px/58px Noto Sans JP;
            color: #2964b6;
            border-bottom: 6px solid #2964b6;
            width: fit-content;
            margin-left: auto;
            margin-right: auto;
            padding-bottom: 16px;
          }

          .box-1 {
          }

          .box-1 p {
            font-size: clamp(19px, calc(23vw / 14.4), 24px);
            letter-spacing: 0px;
            color: #ffffff;
            line-height: min(calc(50vw / 19.2), 50px);
          }
        }
      `}</style>
    </>
  )
}

export default AboutDemolitionWork
